import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/fonts.css';
import './TechMod.css';
import EKSimage from '../assets/images/amazon-eks.svg';
import KubernetesImage from '../assets/images/kubernetes.512x497.png';
import RancherImage from '../assets/images/rancher.svg';
import PythonImage from '../assets/images/logo-python.506x512.png';
import FastAPIImage from '../assets/images/fastapi.512x512.png';
import SQLImage from '../assets/images/sqlquery.512x489.png';
import GitImage from '../assets/images/git-alt.511x512.png';
import GoImage from '../assets/images/golang.512x511.png';
import RustImage from '../assets/images/rust.512x511.png';
import JavascriptImage from '../assets/images/javascript.png';
import TypescriptImage from '../assets/images/typescript.png';
import ReactImage from '../assets/images/react.png';
import KafkaImage from '../assets/images/kafka.png';
import ScalaImage from '../assets/images/scala.png';
import SpringBootImage from '../assets/images/spring-boot.png';
import NodejsImage from '../assets/images/nodejs.png';
import ExpressjsImage from '../assets/images/expressjs.png';
import DVCImage from '../assets/images/dvc.png';
import SonarScannerImage from '../assets/images/sonarscanner.png';
import RDSImage from '../assets/images/rds.png';
import TerraformImage from '../assets/images/terraform.png';
import DockerImage from '../assets/images/docker.png';
import GithubImage from '../assets/images/github.png';
import PrismaImage from '../assets/images/prisma.png';
import VaultImage from '../assets/images/vault.png';
import Ec2Image from '../assets/images/ec2.png';
import S3Image from '../assets/images/s3.png';
import MicroservicesImage from '../assets/images/microservices.png';
import SplunkImage from '../assets/images/splunk.png';
import NewRelicImage from '../assets/images/newrelic.png';
import RubyImage from '../assets/images/ruby.png';
import RHELImage from '../assets/images/redhat.png';
import OpenShiftImage from '../assets/images/openshift.png';
import UbuntuImage from '../assets/images/ubuntu.png';
import CloudWatchImage from '../assets/images/cloudwatch.png';
import RedshiftImage from '../assets/images/redshift.png';




const TechMod: React.FC = () => {
  return (
    <div className="container my-5">
        <div className="row mb-4">
            <div className="col">
                <div className="tech-mod-background-image d-flex align-items-center justify-content-center rounded">
                    <h1 className="text text-start-center text text-start-white">Technology Modernization</h1>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-8 mx-auto">
            <h3 className="mb-4">Our Approach to Modernization</h3>
            <p className="text text-start">
            At KirkpatrickCORE, we believe in a strategic approach to technology modernization, rooted in a thorough understanding of our client's unique requirements and operational environment. We start by conducting an inment of the existing IT infrastructure and understanding the business processes it supports. This analysis helps us identify potential areas of improvement and any existing bottlenecks. 
            </p>
            <p className="text text-start">
            We then develop a tailor-made modernization roadmap, emphasizing incremental improvements to minimize operational disruptions. Our approach is rooted in industry best practices, leveraging the latest technologies, including cloud computing, AI/ML, big data analytics, and more.
            </p>
            <p className="text text-start">
            Our skilled team of engineers and consultants works closely with our clients throughout the implementation process, ensuring seamless migration, efficient knowledge transfer, and optimal system performance. Post-implementation, we provide ongoing support and system enhancements to ensure that the modernized systems continue to deliver value.
            </p>
            <p className="text text-start">
            At KirkpatrickCORE, our goal is to help our clients realize the full potential of their IT investments, making their operations more efficient, scalable, and responsive to their ever-evolving needs.            
            </p>
            </div>
        </div>

        <hr/>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="image-container rounded">
                            <img src={PythonImage} className="card-image" alt="Kubernetes logo" />
                            <h5 className="card-title overlay">Python</h5>
                        </div>
                        <p className="card-text text-start">
                        Python is a versatile and powerful programming language with an emphasis on readability and simplicity. It's widely used in various domains like web development, data analysis, artificial intelligence, and more. Its extensive libraries and frameworks make it a popular choice for both startups and tech giants in their tech stack.
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="image-container rounded">
                            <img src={FastAPIImage} className="card-image" alt="EKS logo" />
                            <h5 className="card-title overlay">FastAPI</h5>
                        </div>
                        <p className="card-text text-start">
                        FastAPI is a modern, fast (high-performance), web framework for building APIs with Python 3.6+ based on standard Python type hints. It's easy to use and has automatic interactive API documentation. FastAPI is excellent for building robust, scalable, and efficient microservices.
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="image-container rounded">
                            <img src={SQLImage} className="card-image" alt="Rancher logo" />
                            <h5 className="card-title overlay">SQL</h5>
                        </div>
                        <p className="card-text text-start">
                        SQL (Structured Query Language) is a standard language for managing and manipulating databases. It's utilized for querying and editing information stored in a certain database management system. SQL is important in the modernization of technology projects as it ensures structured and efficient data management.
                        </p>
                    </div>
                </div>
            </div>
        </div>
      
        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="image-container rounded">
                            <img src={GitImage} className="card-image" alt="Git logo" />
                            <h5 className="card-title overlay">Git</h5>
                        </div>
                        <p className="card-text text-start">
                        Git is a distributed version-control system for tracking changes in any set of files. It's critical in collaborative projects as it allows multiple developers to work together without overwriting each other's changes. Git also maintains a history of changes allowing a project to be rolled back to any previous version.
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="image-container rounded">
                            <img src={GoImage} className="card-image" alt="Go logo" />
                            <h5 className="card-title overlay">Go</h5>
                        </div>
                        <p className="card-text text-start">
                        Go, also known as Golang, is a statically typed, compiled language designed for simplicity and efficiency. It's excellent for building microservices and has first-class support for concurrency, making it ideal for high-performance computing, networking, and cloud-native development in modern technology projects.
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="image-container rounded">
                            <img src={RustImage} className="card-image" alt="Rust logo" />
                            <h5 className="card-title overlay">Rust</h5>
                        </div>
                        <p className="card-text text-start">
                        Rust is a multi-paradigm language designed for performance and safety. It's known for its memory safety without needing a garbage collector. In modern technology projects, Rust can be used to build reliable system-level software, including operating systems, game engines, browsers, and more, while minimizing common programming errors.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                        <img src={JavascriptImage} className="card-image" alt="Javascript logo" />
                        <h5 className="card-title overlay">Javascript</h5>
                    </div>
                    <p className="card-text text-start">
                    JavaScript is a dynamic, high-level programming language that powers most modern websites and web applications by enabling interactive elements. It's also used in backend development through Node.js, making it a versatile option for both front-end and back-end solutions in technology modernization projects.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                        <img src={TypescriptImage} className="card-image" alt="Typescript logo" />
                        <h5 className="card-title overlay">Typescript</h5>
                    </div>
                    <p className="card-text text-start">
                    TypeScript is a strongly typed superset of JavaScript that adds optional types, classes, and modules to the language, making it easier to write and maintain large codebases. It provides the benefits of type-checking and autocompletion, making it a crucial part of modern JavaScript development workflows.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                        <img src={ReactImage} className="card-image" alt="React logo" />
                        <h5 className="card-title overlay">React</h5>
                    </div>
                    <p className="card-text text-start">
                    React is a JavaScript library for building user interfaces, particularly single-page applications where you need a fast, interactive user experience. It enables developers to create reusable UI components, making development faster and easier. It's maintained by Facebook and is widely used in modern web development.
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={NodejsImage} className="card-image" alt="Node.js logo" />
                    <h5 className="card-title overlay">Node.js</h5>
                    </div>
                    <p className="card-text text-start">
                    Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that runs on the V8 engine and executes JavaScript code outside a web browser. It allows developers to use JavaScript to write command line tools and for server-side scripting. It's widely used in modernization projects due to its efficiency and its ability to handle numerous concurrent connections with a single server.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={ExpressjsImage} className="card-image" alt="Express.js logo" />
                    <h5 className="card-title overlay">Express.js</h5>
                    </div>
                    <p className="card-text text-start">
                    Express.js, or simply Express, is a web application framework for Node.js, released as free and open-source software under the MIT License. It's designed for building web applications and APIs. Its minimalistic, flexible, and scalable nature makes it a perfect choice forall and large-scale apps in technology modernization projects.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={DVCImage} className="card-image" alt="DVC logo" />
                    <h5 className="card-title overlay">Data Version Control</h5>
                    </div>
                    <p className="card-text text-start">
                    DVC is an open-source tool for data science and machine learning projects. It leverages the existing engineering toolset that you're already familiar with (Git, CI/CD, etc.) It's crucial in modernization projects as it enables versioning of large datasets, ML models, and allows for efficient data pipelines, making data science projects more reproducible and collaborative.
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={DockerImage} className="card-image" alt="Docker logo" />
                    <h5 className="card-title overlay">Docker</h5>
                    </div>
                    <p className="card-text text-start">
                    Docker is an open platform for developing, shipping, and running applications. Docker enables you to separate your applications from your infrastructure so you can deliver software quickly. With Docker, you can manage your infrastructure in the same ways you manage your applications providing key advantages in technology modernization projects.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={GithubImage} className="card-image" alt="Github Enterprise logo" />
                    <h5 className="card-title overlay">Github Enterprise</h5>
                    </div>
                    <p className="card-text text-start">
                    Github Enterprise is a development platform for hosting and reviewing code, managing projects, and building software alongside millions of other developers. It offers the collaborative approach of Github combined with the security, administrative, and audit capabilities demanded by enterprises in their modernization projects.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={PrismaImage} className="card-image" alt="Prisma logo" />
                    <h5 className="card-title overlay">Prisma</h5>
                    </div>
                    <p className="card-text text-start">
                    Prisma Cloud is a comprehensive cloud-native security platform that provides visibility, threat prevention, compliance, and data security for any application, across any cloud environment. By integrating security into the developmentma Cloud helps organizations build secure applications from the start, significantly reducing potential risks and vulnerabilities.
                    </p>
                </div>
                </div>
            </div>
        </div>


        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={KubernetesImage} className="card-image" alt="Kubernetes logo" />
                    <h5 className="card-title overlay">Kubernetes</h5>
                    </div>
                    <p className="card-text text-start">
                    Kubernetes is an open-source container orchestration system that automates application deployment, scaling, and management. Its widespread adoption and flexibility make it an integral part of modern cloud-native infrastructures, enabling seamless scalability and efficient resource usage.
                    </p>
                </div>
                </div>
            </div>

            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={EKSimage} className="card-image" alt="EKS logo" />
                    <h5 className="card-title overlay">AWS EKS Clusters</h5>
                    </div>
                    <p className="card-text text-start">
                    Amazon Elastic Kubernetes Service (EKS) simplifies the process of running Kubernetes in the AWS cloud, eliminating the need to install, operate, and maintain the orchestration service. AWS EKS clusters facilitate modernization by allowing you to easily deploy, manage, and scale containerized applications using Kubernetes.
                    </p>
                </div>
                </div>
            </div>

            <div className="col-md-4">
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="image-container rounded">
                            <img src={RancherImage} className="card-image" alt="Rancher logo" />
                            <h5 className="card-title overlay">Rancher</h5>
                        </div>
                        <p className="card-text text-start">
                        Rancher is an open-source multi-cluster Kubernetes management tool. It simplifies the operation of Kubernetes and enables the efficient deployment of applications to any cloud or on-premises infrastructure. By facilitating Kubernetes management, Rancher aids in the modernization of infrastructure and the seamless scaling of applications.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={KafkaImage} className="card-image" alt="Kafka logo" />
                    <h5 className="card-title overlay">Kafka</h5>
                    </div>
                    <p className="card-text text-start">
                    Kafka is a distributed event streaming platform used by thousands of companies for high-performance data pipelines, streaming analytics, data integration, and mission-critical applications. It supports real-time data feeds and has robust durability guarantees, making it an essential component in many modern data architectures.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={ScalaImage} className="card-image" alt="Scala logo" />
                    <h5 className="card-title overlay">Scala</h5>
                    </div>
                    <p className="card-text text-start">
                    Scala is a high-level programming language that combines object-oriented and functional programming in one concise, high-level language. Scala's static types help avoid bugs in complex applications, and its JVM and JavaScript runtimes let you build high-performance systems with easy access to huge ecosystems of libraries.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={SpringBootImage} className="card-image" alt="Java logo" />
                    <h5 className="card-title overlay">Spring Boot</h5>
                    </div>
                    <p className="card-text text-start">
                    Spring Boot is an open-source Java-based framework used to create a stand-alone, production-grade, and easily deployable microservices. It's designed to simplify the setup and development of Spring applications, reducing development time and increasing efficiency - a perfect fit for technology modernization initiatives.
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={SonarScannerImage} className="card-image" alt="SonarScanner logo" />
                    <h5 className="card-title overlay">SonarScanner</h5>
                    </div>
                    <p className="card-text text-start">
                    SonarScanner is an integral component of SonarQube, designed for code quality analysis and security detection. It scans code for bugs, vulnerabilities, andells. In technology modernization projects, it's used to ensure that developed applications meet quality standards and are free from security threats.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={RDSImage} className="card-image" alt="RDS logo" />
                    <h5 className="card-title overlay">Amazon RDS</h5>
                    </div>
                    <p className="card-text text-start">
                    Amazon RDS (Relational Database Service) is a managed relational database service by Amazon Web Services. It's designed to simplify the setup, operation, and scaling of a relational database in the cloud. It provides cost-efficient and resizable capacity while managing time-consuming database administration tasks, freeing developers to focus on their applications and business.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={TerraformImage} className="card-image" alt="Terraform logo" />
                    <h5 className="card-title overlay">Terraform</h5>
                    </div>
                    <p className="card-text text-start">
                    Terraform is an Infrastructure as Code (IaC) tool that provides a consistent CLI workflow for managing cloud service. It codifies APIs into declarative configuration files, which can be shared among team members, treated as code, edited, reviewed, and versioned. In technology modernization projects, it's used to automate and simplify infrastructure deployment.
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={VaultImage} className="card-image" alt="Vault logo" />
                    <h5 className="card-title overlay">Hashicorp Vault</h5>
                    </div>
                    <p className="card-text text-start">
                    HashiCorp Vault is a tool for securely accessing secrets such as API keys, passwords, or certificates. Vault provides a unified interface to any secret while providing tight access control and recording a detailed audit log. It's vital in modern technology projects for secret management, ensuring sensitive data is stored securely and accessed responsibly.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={Ec2Image} className="card-image" alt="AWS EC2 logo" />
                    <h5 className="card-title overlay">AWS EC2</h5>
                    </div>
                    <p className="card-text text-start">
                    Amazon EC2 (Elastic Compute Cloud) is a web service that provides resizable compute capacity in the cloud. It's designed to make web-scale computing easier for developers. EC2's simple web service interface allows you to obtain and configure capacity with minimal friction, making it a cornerstone of modern cloud-based technology projects.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={S3Image} className="card-image" alt="AWS S3 logo" />
                    <h5 className="card-title overlay">AWS S3</h5>
                    </div>
                    <p className="card-text text-start">
                    Amazon S3 (Simple Storage Service) is an object storage service that offers industry-leading scalability, data availability, security, and performance. This means customers of all sizes and industries can use it to store and protect any amount of data for a range of use cases, such as websites, mobile applications, backup and restore, archive, enterprise applications, IoT devices, and big data analytics.
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={MicroservicesImage} className="card-image" alt="Microservices logo" />
                    <h5 className="card-title overlay">Microservices</h5>
                    </div>
                    <p className="card-text text-start">
                    Microservices is an architectural style that structures an application as a collectionall autonomous services, modeled around a business domain. It enables the continuous delivery/deployment of complex applications. Moreover, it improves the organization's capability to design, implement, and scale services independently of each other.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={SplunkImage} className="card-image" alt="Splunk logo" />
                    <h5 className="card-title overlay">Splunk</h5>
                    </div>
                    <p className="card-text text-start">
                    Splunk is a software platform to search, analyze, and visualize the machine-generated data gathered from the websites, applications, sensors, devices, etc. that make up your IT infrastructure and business. Splunk can enhance a government project's visibility into its operations, helping to detect patterns and prevent issues before they arise.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={NewRelicImage} className="card-image" alt="New Relic logo" />
                    <h5 className="card-title overlay">New Relic</h5>
                    </div>
                    <p className="card-text text-start">
                    New Relic is a powerful, flexible, and intuitive platform that combines telemetry data from mobile, browser, and server applications. It offers full-stack observability and allows developers to track and optimize their applications' performance, pinpoint and solve issues faster, and drive overall business success. 
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={RubyImage} className="card-image" alt="Ruby logo" />
                    <h5 className="card-title overlay">Ruby</h5>
                    </div>
                    <p className="card-text text-start">
                    Ruby is a dynamic, open source, object-oriented programming language with a focus on simplicity and productivity. It has an elegant syntax that is natural to read and easy to write, making it suitable for a multitude of tasks, from simple scripts to complex web applications. Its most popular implementation, Ruby on Rails, is highly prized in tech modernization projects due to its emphasis on convention over configuration.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={RHELImage} className="card-image" alt="RHEL logo" />
                    <h5 className="card-title overlay">Red Hat Enterprise Linux</h5>
                    </div>
                    <p className="card-text text-start">
                    Red Hat Enterprise Linux (RHEL) is a highly robust, stable, and secure open-source operating system designed for enterprise-level computing. It provides a reliable foundation that supports all major hardware platforms and thousands of apps. With its excellent security features and scalability, RHEL is an essential component in modernizing technology infrastructure.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={OpenShiftImage} className="card-image" alt="OpenShift logo" />
                    <h5 className="card-title overlay">Red Hat OpenShift</h5>
                    </div>
                    <p className="card-text text-start">
                    Red Hat OpenShift is a powerful, open-source container application platform that automates the provisioning, management, and scaling of applications. It's built on top of Docker container packaging and Kubernetes container cluster management. OpenShift is well-suited for technology modernization projects, allowing for faster, more secure, and scalable deployment of applications.
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div className="row mt-5">
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={UbuntuImage} className="card-image" alt="Ubuntu logo" />
                    <h5 className="card-title overlay">Ubuntu</h5>
                    </div>
                    <p className="card-text text-start">
                    Ubuntu is a popular open-source operating system based on Linux. It's favored for its user-friendly design and robust security features. In technology modernization projects, Ubuntu provides a stable platform for deploying applications on servers, desktops, and clouds, benefiting both developers and system administrators.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={CloudWatchImage} className="card-image" alt="Cloudwatch logo" />
                    <h5 className="card-title overlay">AWS Cloudwatch</h5>
                    </div>
                    <p className="card-text text-start">
                    AWS Cloudwatch is a monitoring and observability service from Amazon Web Services. It provides data and actionable insights for monitoring applications, understanding system-wide performance, and managing resource utilization. For technology modernization projects, Cloudwatch is crucial for maintaining the health of applications and promptly responding to system or performance changes.
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="image-container rounded">
                    <img src={RedshiftImage} className="card-image" alt="Redshift logo" />
                    <h5 className="card-title overlay">Amazon Redshift</h5>
                    </div>
                    <p className="card-text text-start">
                    Amazon Redshift is a fully managed, petabyte-scale data warehouse service in the cloud. It allows users to analyze data with their favorite analysis tools using standard SQL. Redshift is designed for high-performance analysis of large datasets and integrates with various data loading and ETL tools, making it invaluable in modern, data-driven technology projects.
                    </p>
                </div>
                </div>
            </div>
        </div>


        <div className="row mt-5">
            <div className="col-md-8 mx-auto">
                <h3 className="mb-4">Get in Touch</h3>
                <p className="card-text text-start text text-start-start">
                We invite you to take the first step towards technology modernization for your organization. Our expert team is eager to understand your challenges and objectives, and collaborate to craft bespoke solutions that align with your strategic goals. Whether it's leveraging the power of artificial intelligence and machine learning, or streamlining your operations with cloud-based solutions, we're committed to driving transformation that delivers tangible results. 
                </p>
                <p className="card-text text-start text text-start-start">
                Please contact us to learn more about how our services can help you unlock your potential. We look forward to partnering with you on your journey towards digital excellence.
                </p>
            </div>
        </div>

    </div>
  );
};

export default TechMod;
